import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af15954c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-menu" }
const _hoisted_2 = { class: "chart-arrow" }
const _hoisted_3 = { class: "time-frames custom-checkboxes-group" }
const _hoisted_4 = { class: "time-frames-checkboxes custom-checkboxes" }
const _hoisted_5 = ["id", "name", "checked", "onInput"]
const _hoisted_6 = { class: "chart-arrow" }

import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  emits: ['arrowClick', 'timeFrameUpdate'],
  setup(__props, { emit }) {

  

  let selectedTimeFrame = ref('month')
  const timeFrames = ['week', 'month', 'year']

  function onUpdateTimeFrame(timeFrame: string) {
    selectedTimeFrame.value = timeFrame
    emit('timeFrameUpdate', timeFrame)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: "fa fa-chevron-left",
        "aria-hidden": "true",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('arrowClick', true)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeFrames, (frame) => {
          return _createElementVNode("div", {
            class: "time-frame custom-checkbox",
            key: frame
          }, [
            _createElementVNode("label", null, [
              _createElementVNode("input", {
                type: "radio",
                id: frame,
                name: frame,
                checked: _unref(selectedTimeFrame) === frame,
                onInput: ($event: any) => (onUpdateTimeFrame(frame))
              }, null, 40, _hoisted_5),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`statistics.TIME_FRAMES.${frame}`)), 1)
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("i", {
        class: "fa fa-chevron-right",
        "aria-hidden": "true",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('arrowClick', false)))
      })
    ])
  ]))
}
}

})